import { User } from '@/types/user'

type ThemeConfig = {
  title: string
  icon: string
  theme: Record<string, string>
}

type DomainConfigs = Record<string, ThemeConfig> & {
  default: ThemeConfig
}

export const domainConfigs: DomainConfigs = {
  '48762505000110': {
    title: 'Trisolution',
    icon: '/48762505000110.svg',
    theme: {
      '--primary-color': '#12142D',
      '--primary-hover': '#0F3984',
      '--text-color': '#F1FFE8'
    }
  },
  // '46553339000116': {
  //   title: 'MD Tributaria',
  //   icon: '/46553339000116.svg',
  //   theme: {
  //     '--primary-color': '#0A3838',
  //     '--primary-hover': '#1D5959',
  //     '--text-color': '#A5A5A4'
  //   }
  // },
  // '46151037000111': {
  //   title: 'Bahia Sul',
  //   icon: '/46151037000111.svg',
  //   theme: {
  //     '--primary-color': '#122724',
  //     '--primary-hover': '#3A5753',
  //     '--text-color': '#BFAB50'
  //   }
  // },
  '59754843000126': {
    title: 'DS Consultoria',
    icon: '/59754843000126.svg',
    theme: {
      '--primary-color': '#3a3850',
      '--primary-hover': '#90949f',
      '--text-color': '#f7c13a'
    }
  },
  default: {
    title: 'Klinger',
    icon: '/50734366000162.svg',
    theme: {
      '--primary-color': '#0D0D0D',
      '--primary-hover': '#424242',
      '--text-color': '#F2F2F2'
    }
  }
}

export function applyTheme(tenantId: string, isAdmin: boolean, userId?: User | null): void {
  let config: ThemeConfig

  if (isAdmin) {
    config = domainConfigs[tenantId] || domainConfigs.default
  } else {
    config = domainConfigs[userId?.id_tenant as keyof typeof domainConfigs] || domainConfigs.default
  }

  const rootElement = document.documentElement
  Object.entries(config.theme).forEach(([key, value]) => {
    rootElement.style.setProperty(key, value)
  })
}

export function getTenantName(tenantId: string | null): string | null {
  if (!tenantId) return null

  const tenantMap: Record<string, string> = {
    // '46151037000111': 'Bahia Sul',
    '48762505000110': 'Trisolutions',
    '46553339000116': 'MD Tributaria',
    '59754843000126': 'DS Consultoria'
  }

  return tenantMap[tenantId] || null
}
